import script from "./VolPayDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./VolPayDialog.vue?vue&type=script&setup=true&lang=js"

import "@/features/comic/styles/VolPayDialog.css?vue&type=style&index=0&id=5eaed622&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eaed622"]])

export default __exports__